module.exports = __webpack_public_path__ + "static/media/storefront.11f50ac0.svg";